export enum SellerEntityTypes {
    FREELANCER = 'freelancer',
    AGENCY = 'agency',
    TEAM = 'team',
}
